import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
	},
	header: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: THEME.spacing.md,
	},
	title: {
		fontSize: THEME.typography.fontSizes.md,
		fontWeight: THEME.typography.fontWeights.semibold,
		color: THEME.colors.text.main,
		margin: 0,
	},
	headerFilters: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.sm,
	},
	emptyState: {
		padding: THEME.spacing.xl,
		textAlign: 'center',
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
	},
	emptyStateFiltered: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: THEME.spacing.xs,
		padding: `${THEME.spacing.xxl}px ${THEME.spacing.xl}px`,
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
	},
	emptyStateFilteredTitle: {
		fontSize: THEME.typography.fontSizes.md,
		fontWeight: THEME.typography.fontWeights.semibold,
		color: THEME.colors.text.main,
		margin: 0,
	},
	emptyStateFilteredMessage: {
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.light,
		margin: 0,
	},
	tableWrapper: {
		overflowX: 'auto',
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
	},
	table: {
		width: '100%',
		borderCollapse: 'collapse',
		backgroundColor: THEME.colors.background.light,
	},
	th: {
		padding: `${THEME.spacing.sm}px ${THEME.spacing.md}px`,
		textAlign: 'left',
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.semibold,
		color: THEME.colors.text.main,
		borderBottom: THEME.common.border,
		backgroundColor: THEME.colors.hover.light,
		whiteSpace: 'nowrap',
	},
	tr: {
		borderBottom: THEME.common.border,
		':last-child': { borderBottom: 'none' },
	},
	td: {
		padding: `${THEME.spacing.sm}px ${THEME.spacing.md}px`,
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.main,
		verticalAlign: 'middle',
	},
});
